/** Reference combinations exercised in CI / manual device checks. */
export const TESTED_COMBINATIONS = [
    { label: 'WebGL2 baseline', backend: 'webgl2', flags: { webgl2: true, environmentMaps: true } },
    {
        label: 'WebGL2 without environment',
        backend: 'webgl2',
        flags: { webgl2: true, environmentMaps: false },
    },
    {
        label: 'WebGPU primary (when available)',
        backend: 'webgpu',
        flags: { webgpu: true, webgl2: true, postProcessing: true, transmission: true },
    },
    {
        label: 'Limited fallback',
        backend: 'limited',
        flags: { webgl2: false, environmentMaps: false, postProcessing: false },
    },
];
/** Resolve effect flags from runtime probes. */
export function buildCapabilityMatrix(probes) {
    const backend = probes.webgpu
        ? 'webgpu'
        : probes.webgl2
            ? 'webgl2'
            : 'limited';
    const flags = {
        webgpu: probes.webgpu,
        webgl2: probes.webgl2,
        environmentMaps: probes.webgl2,
        postProcessing: probes.webgpu,
        contactShadows: probes.webgl2,
        transmission: probes.webgpu,
        instancing: probes.webgl2 || probes.webgpu,
    };
    const disabledEffects = [];
    if (!flags.environmentMaps)
        disabledEffects.push('environmentMaps');
    if (!flags.postProcessing)
        disabledEffects.push('postProcessing');
    if (!flags.contactShadows)
        disabledEffects.push('contactShadows');
    if (!flags.transmission)
        disabledEffects.push('transmission');
    if (!flags.instancing)
        disabledEffects.push('instancing');
    const notes = [];
    if (backend === 'webgl2') {
        notes.push('WebGPU effects gated; WebGL2 compatibility path active');
    }
    if (backend === 'limited') {
        notes.push('Neither WebGPU nor WebGL2 detected — viewer degraded');
    }
    return { backend, flags, disabledEffects, notes };
}
/** Apply matrix to viewer options — disable unsupported effects. */
export function applyEffectGating(matrix, effects) {
    const gated = { ...effects };
    for (const key of matrix.disabledEffects) {
        if (key in gated) {
            gated[key] = false;
        }
    }
    return gated;
}
//# sourceMappingURL=capability-matrix.js.map